<template>
  <div v-if="case_none" class="stars">
    <StarIcon class="star-inactive" aria-hidden="true" />
    <StarIcon class="star-inactive" aria-hidden="true" />
    <StarIcon class="star-inactive" aria-hidden="true" />
  </div>
  <div v-if="case_low" class="stars">
    <StarIcon class="star-active" aria-hidden="true" />
    <StarIcon class="star-inactive" aria-hidden="true" />
    <StarIcon class="star-inactive" aria-hidden="true" />
  </div>
  <div v-if="case_medium" class="stars">
    <StarIcon class="star-active" aria-hidden="true" />
    <StarIcon class="star-active" aria-hidden="true" />
    <StarIcon class="star-inactive" aria-hidden="true" />
  </div>
  <div v-if="case_high" class="stars">
    <StarIcon class="star-active" aria-hidden="true" />
    <StarIcon class="star-active" aria-hidden="true" />
    <StarIcon class="star-active" aria-hidden="true" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
const props = defineProps({value: String});
const case_none = computed(() => props.value == 'none');
const case_low = computed(() => props.value == 'low');
const case_medium = computed(() => props.value == 'medium');
const case_high = computed(() => props.value == 'high');
</script>

<style scoped>
.stars
{
  @apply flex flex-row;
}

.star-active
{
  @apply text-yellow-400 h-5 w-5 flex-shrink-0;
}

.star-inactive
{
  @apply text-gray-200 h-5 w-5 flex-shrink-0;
}

</style>
